
import { useEffect, useRef, useState } from "react";

const AddressPopUp = (props) => {
  const popupref = useRef(null);
  const { items = [], visible = false } = props;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.onClickOutside && props.onClickOutside();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [popupref]);

  return (
    visible && (
      <div
        ref={popupref}
        className={`w-[300px] bg-white border border-gray-300 rounded-md overflow-y-auto gk-scr p-[10px] absolute z-30 top-[50px] left-[0px] self-start shadow-lg`}
        style={props.style}
      >
        <div className="w-full overflow-y-auto max-h-[220px]">
          {items.length === 0 && (
            <p className="text-sm text-gray-500 p-2">No addresses found.</p>
          )}
          {items.map((item, index) => (
            <div
              key={item.id || index}
              onClick={() => props.onSelect(item)}
              className="flex items-center w-full py-2 px-2 cursor-pointer hover:bg-themeColor hover:text-white text-textcolor hover:px-[10px] hover:rounded-xl"
            >
              <p className="font-medium text-sm ml-[8px]">{item.propertyaddress}</p>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default AddressPopUp;
